import {
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowUpRight,
  Bell,
  Bookmark,
  Folder,
  BookmarkPlus,
  Bot,
  Building2,
  Flag,
  Calendar,
  CalendarCheck,
  CalendarDays,
  CalendarPlus,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CircleDollarSign,
  Clock,
  Contrast,
  CreditCard,
  CopyIcon,
  Download,
  Crown,
  Eye,
  EyeOff,
  FileCheck,
  FileSearch,
  Filter,
  Forward,
  Globe,
  GripVertical,
  Heart,
  HelpCircle,
  Hexagon,
  House,
  Image,
  Info,
  LayoutGrid,
  LayoutPanelTop,
  LetterText,
  List,
  ListChecks,
  Link,
  Lock,
  LocateFixed,
  LogOut,
  type LucideIcon,
  Mail,
  MapPin,
  Menu,
  MessageSquareTextIcon,
  MoreHorizontal,
  MousePointerClick,
  PaletteIcon,
  PartyPopper,
  PenTool,
  PencilIcon,
  Pipette,
  Minus,
  Plus,
  Printer,
  RefreshCw,
  Repeat,
  School,
  Scissors,
  Search,
  Settings,
  Settings2,
  Smile,
  Star,
  StarOff,
  Sun,
  TagIcon,
  ThumbsDown,
  ThumbsUp,
  ToggleRight,
  Trash2Icon,
  Upload,
  UserRound,
  UserRoundCheck,
  WandSparkles,
  Rss,
  XIcon,
  Zap,
  CopyPlus,
  SquarePen,
  Share2,
  Sliders,
} from 'lucide-react';
import type { IconType as ReactIconsType } from 'react-icons';

export type IconType = LucideIcon | ReactIconsType;

export const Icons = {
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowUpRight,
  Bell,
  Bookmark,
  BookmarkPlus,
  Bot,
  Building2,
  Calendar: CalendarDays,
  CalendarCheck: CalendarCheck,
  CalendarPlus: CalendarPlus,
  CalendarBlank: Calendar,
  Checkmark: Check,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  ChevronUp,
  CircleDollarSign,
  Clock,
  Contrast,
  Copy: CopyIcon,
  Download,
  CopyPlus,
  CreditCard,
  Crown,
  Eye,
  EyeOff,
  FileCheck,
  FileSearch,
  Filter,
  Flag,
  Folder,
  Forward,
  Globe,
  GripVertical,
  Heart,
  HelpCircle,
  Hexagon,
  House,
  Image,
  Info,
  Layout: LayoutPanelTop,
  LayoutGrid,
  LetterText,
  List,
  ListChecks,
  Link,
  Lock,
  Logout: LogOut,
  Target: LocateFixed,
  Mail,
  MapPin,
  Menu,
  MoreHorizontal,
  MousePointerClick,
  Pipette,
  PenTool,
  Pencil: PencilIcon,
  Palette: PaletteIcon,
  PartyPopper,
  Minus,
  Plus,
  Printer,
  Refresh: RefreshCw,
  Repeat,
  School,
  Scissors,
  Search,
  Settings,
  Settings2,
  Share: Forward,
  Share2: Share2,
  Sliders,
  Smile,
  Star,
  StarOff,
  Sun,
  SquarePen,
  Tag: TagIcon,
  TextMessage: MessageSquareTextIcon,
  ThumbsDown,
  ThumbsUp,
  ToggleRight,
  Trash: Trash2Icon,
  Upload,
  User: UserRound,
  UserCheck: UserRoundCheck,
  WandSparkles,
  Rss,
  X: XIcon,
  Zap,
} as const satisfies Record<string, IconType>;
